const PubSub = window.PubSub;
const $ = window.jQuery;

function is_touch_device() {
  return 'ontouchstart' in window        // works on most browsers 
      || navigator.maxTouchPoints;       // works on IE10/11 and Surface
};

class CardBlade {
	constructor() {
		this.prevWidth = null;
		this.prevBodyHeight = null;
		this.cachedHeight = {};

		PubSub.subscribe('ready', this.init.bind(this));
		PubSub.subscribe('draw', this.draw.bind(this));
	}
	init() {
		var self = this;

		this.cardBlades = $('.component.card-blade').each(function(index, elem) {
			var cardBlade = $(elem);
			var blades = cardBlade.find('.blade').each(function(index, elem) {
				var blade = $(elem);
				blade.addClass((index === 0) ? 'active' : 'inactive');

				var activate = function() {
					if (self.prevWidth < 768) {
						if (blade.hasClass('expanded')) {
							blade.find('.content').slideUp();
						} else {
							blade.find('.content').slideDown();
						}
						blade.toggleClass('expanded');
					}

					blades
						.addClass('inactive')
						.removeClass('active');

					blade
						.addClass('active')
						.removeClass('inactive');
					};

				var tab = blade.find('.tab');

				tab.on('click', function(event) {
					activate();
					if (self.prevWidth >= 768) {
                        var url = blade.find('.tab .text').attr('data-url');
                        if (url) {
                            document.location = url;
                        }
                    }                
                }).on('mouseenter', function(event) {
					if (self.prevWidth < 768 || is_touch_device())
						return;

					waitReadySetGo(333, (d) => {
						d.offHandler = () => {
							d.cancel();
						};
						tab.on('mouseleave', d.offHandler);
					}, (d) => {
						activate();
					}, (d) => {
						tab.off('mouseleave', d.offHandler);
					})
				});
			});
		});
	}
	draw(topic, args) {
		var self = this;

		if (args && args.width && (this.prevWidth != args.width || this.prevBodyHeight != document.body.scrollHeight)) {
			this.prevWidth = args.width;
			this.prevBodyHeight = document.body.scrollHeight;

			this.cardBlades.each(function(index, elem) {
				var cardBlade = $(elem);
				var maxHeight = 0;
				var tabs = cardBlade.find('.tab .box');
				var texts = cardBlade.find('.content .text');

				tabs.css('height', 'auto');
				tabs.each(function(index, elem) {
					var tabRect = elem.getBoundingClientRect();
					if (tabRect.height > maxHeight) {
						maxHeight = tabRect.height;
					}
				});


				if (maxHeight > 0 && self.cachedHeight[index] != maxHeight) {
					self.cachedHeight[index] = maxHeight;
					tabs.css('height', maxHeight + 'px');
					texts.css('margin-bottom', (maxHeight + 90) + 'px');
				}
			});
		}
	}
}

export default new CardBlade();